module.exports = __webpack_public_path__ + "img/icon-extra.45c07973.svg";